import {
  businessUnitsKeys,
  RequestTypes,
} from '@core/react-query/features/businessUnits'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { BusinessUnit, IBusinessUnit } from '@core/entities/businessUnit'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetBusinessUnit = (
  payload: RequestTypes['getBusinessUnit'],
  options?: UseQueryOptions<BusinessUnit, RequestErrorType, IBusinessUnit>,
) => {
  return useQuery({
    select: BusinessUnit.new,
    ...businessUnitsKeys.getBusinessUnit(payload),
    enabled: !!payload.businessUnitId,
    retry: 3,
    ...options,
  })
}
